import { fetchAuthSession } from "@aws-amplify/auth";
import { useEffect, useState } from "react";

import LoadingState from "../components/ui/LoadingState";
import LoginScreen from "./LoginScreen";

type AuthState = "loading" | "signed_in" | "signed_out";

export default function AuthGate({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<AuthState>("loading");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const session = await fetchAuthSession();
        if (cancelled) return;
        setState(session.tokens?.idToken ? "signed_in" : "signed_out");
      } catch {
        if (!cancelled) setState("signed_out");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "loading") {
    return <LoadingState label="Checking your sign-in…" className="pt-24" />;
  }
  if (state === "signed_out") {
    return <LoginScreen onSignedIn={() => setState("signed_in")} />;
  }
  return <>{children}</>;
}
